import { render, staticRenderFns } from "./Emulator.vue?vue&type=template&id=2b195a6c&scoped=true&"
import script from "./Emulator.vue?vue&type=script&lang=js&"
export * from "./Emulator.vue?vue&type=script&lang=js&"
import style0 from "./Emulator.vue?vue&type=style&index=0&id=2b195a6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b195a6c",
  null
  
)

export default component.exports